import React from "react";

const AboutMilesEducationDesktop = () => {
  return (
    <>
      <div className="w-full justify-center py-12 bg-[#5BB3FF] md:block hidden">
        <div className="bg-[#F4F4F4] max-w-[1120px] mx-auto h-auto px-8 rounded-[24px] shadow-lg flex flex-col items-center justify-center">
          {/* Title Section */}
          <div className="w-full text-center py-5">
            <h2 className="text-[#071B30] font-[Work Sans] text-[36px] font-semibold leading-normal tracking-[-1.44px]">
              <span className="border-[#ca7216] border-b-[4px]">
                About Miles Education
              </span>
            </h2>
          </div>

          {/* Content Section */}
          <div className="flex flex-col md:flex-row items-center mb-5">
            {/* Image Section */}
            <div className="md:w-[37%] flex justify-center">
              <img
                src="/about-us/vj.webp"
                alt="Miles Education"
                className="rounded-[24px] w-[438px] h-[340px] object-cover mt-[5%]"
              />
            </div>

            {/* Text Section */}
            <div className="flex flex-col md:w-[635px] w-full pl-8 items-start gap-2 mt-5">
              <p className="text-[#5C5C5C] mb-2 text-[18px] leading-[24px] font-medium tracking-[-0.72px]">
                The global talent landscape has critical gaps, but at Miles
                Education, we’re not just filling these voids—we’re building
                pathways to success. Driven by our mission to work backward from
                industry shortages, skill gaps, and opportunities, we empower
                businesses and enable talent by combining academic learning with
                hands-on experience through our unique ED-WORK Pedagogy. This
                approach equips students with practical skills and real-world
                insights as we address shortages across accounting, healthcare,
                business, and technology.
              </p>
              <h3 className="text-[24px] font-bold text-[#1D1D1D] mb-2">
                Outcomes First:
              </h3>
              <p className="text-[#5C5C5C] mb-2 text-[18px] leading-[24px] font-medium tracking-[-0.72px]">
                We don’t believe in cookie-cutter education. We start by
                analyzing industry needs, then meticulously craft transformative
                learning pathways that prime talent for success.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutMilesEducationDesktop;
